// import { Routes, Route } from "react-router-dom";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";

import "./components/utils/DataTablesUtils";
import Layout from "./components/layout/Layout.jsx";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import ErrorPage from "./components/ErrorPage.js";
//import Game from "./components/game/Game";
import Home from "./components/home/Home";
import Login from "./components/auth/Login";
import ChangePassword from "./components/auth/ChangePassword";

import Rules from "./components/access/Rules.jsx";
import Roles from "./components/access/Roles.jsx";
import SettingAccess from "./components/access/SettingAccess.jsx";
import SysUsers from "./components/access/SysUsers.jsx";
import SysUser from "./components/access/SysUser.jsx";
import LogLists from "./components/access/LogLists.jsx";

import Knapdata from "./components/page/Control/KNAP/KnapConnect.jsx";

import Lsnstate from "./components/page/Control/LsnState.jsx";
import Mcconnect from "./components/page/Control/MC/McConnect.jsx";
import CHpylsnConnect from "./components/page/Control/CH/CHpylsnConnect.jsx";
import VpylsnConnect from "./components/page/Control/VPY/VpylsnConnect.jsx";
import NapData from "./components/page/Protocols/NapData.jsx";
import MsData from "./components/page/Protocols/MsData.jsx";
import CHpylsnData from "./components/page/Protocols/CHpylsnData.jsx";
import VpyData from "./components/page/Protocols/VpyData.jsx";
import Lsn from "./components/page/Configuration/LSN/Lsn.jsx";
import MfuncStations from "./components/page/Configuration/MfS/MfuncStations.jsx";
import KKSStations from "./components/page/Configuration/MfS/KKSStations.jsx";
import LoginHistory from "./components/access/LoginHistory.jsx";
import Events from "./components/others/Events.jsx";
import VirtualEnv from "./components/others/VirtualEnv.jsx";
import AccessObjects from "./components/others/AccessObjects.jsx";
import PuvSRKState from "./components/page/Control/PuvSRKState.jsx";
import ERAState from "./components/page/Control/ERAState.jsx";
import KonsulState from "./components/page/Control/KonsulState.jsx";
import KnapConnectWithMap from "./components/page/Control/KNAP/KnapConnectWithMap.jsx";
import MsDataMod from "./components/page/Protocols/MsDataMod.jsx";
import Performance from "./components/page/Protocols/Performance.jsx";
import Serviceability from "./components/page/Protocols/Serviceability.jsx";
import APKKonsul from "./components/page/Protocols/APKKonsul.jsx";
import ERAStations from "./components/page/Configuration/MfS/ERAStations.jsx";
import PUVSRKStations from "./components/page/Configuration/MfS/PUVSRKStations.jsx";
import KONSULStations from "./components/page/Configuration/MfS/KONSULStations.jsx";
import VISStations from "./components/page/Configuration/MfS/VISStations.jsx";
import VISState from "./components/page/Control/VISState.jsx";
let timer;

const App = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/reset_password/:token/:login" element={<ResetPassword />} />
      <Route path="/" element={<Layout />} errorElement={<ErrorPage />}>
        <Route index element={<Home />} />
        {/* <Route index element={<Lsnstate />} /> */}
        <Route path="changepassword" element={<ChangePassword />} errorElement={<ErrorPage />} />
        <Route path="rules" element={<Rules />} errorElement={<ErrorPage />} />
        <Route path="rules/:id/roles" element={<SettingAccess />} errorElement={<ErrorPage />} />
        <Route path="roles" element={<Roles />} errorElement={<ErrorPage />} />
        <Route path="roles/:id/rules" element={<SettingAccess />} errorElement={<ErrorPage />} />
        <Route
          path="roles/:id/sys_users"
          element={<SettingAccess />}
          errorElement={<ErrorPage />}
        />
        <Route path="sys_users" element={<SysUsers />} errorElement={<ErrorPage />} />
        <Route path="sys_users/:id" element={<SysUser />} errorElement={<ErrorPage />} />
        <Route path="log_lists" element={<LogLists />} errorElement={<ErrorPage />} />
        <Route path="loginhistory" element={<Events />} errorElement={<ErrorPage />} />
        <Route path="virtual_env" element={<VirtualEnv />} errorElement={<ErrorPage />} />
        <Route path="access_objects" element={<AccessObjects />} errorElement={<ErrorPage />} />

        {/* <Route path="operators" element={<Operators />} errorElement={<ErrorPage />} /> */}

        <Route path="sysstate" element={<Lsnstate />} errorElement={<ErrorPage />} />
        <Route path="knapdata" element={<Knapdata />} errorElement={<ErrorPage />} />
        <Route path="puvsrkstate" element={<PuvSRKState />} errorElement={<ErrorPage />} />
        <Route path="erastate" element={<ERAState />} errorElement={<ErrorPage />} />
        <Route path="konsulstate" element={<KonsulState />} errorElement={<ErrorPage />} />
        <Route path="visstate" element={<VISState />} errorElement={<ErrorPage />} />

        {/* <Route path="msconnect" element={<Mcconnect />} errorElement={<ErrorPage />} /> */}
        <Route path="chpylsnconnect" element={<CHpylsnConnect />} errorElement={<ErrorPage />} />
        {/* <Route path="vpylsnconnect" element={<VpylsnConnect />} errorElement={<ErrorPage />} /> */}

        <Route path="knapmapdata" element={<KnapConnectWithMap />} errorElement={<ErrorPage />} />
        <Route path="napdata" element={<NapData />} errorElement={<ErrorPage />} />
        <Route path="msdata" element={<MsData />} errorElement={<ErrorPage />} />
        <Route path="msdatamod" element={<MsDataMod />} errorElement={<ErrorPage />} />
        <Route path="performance" element={<Performance />} errorElement={<ErrorPage />} />
        <Route path="serviceability" element={<Serviceability />} errorElement={<ErrorPage />} />
        <Route path="konsul" element={<APKKonsul />} errorElement={<ErrorPage />} />

        {/* <Route path="chpylsndata" element={<CHpylsnData />} errorElement={<ErrorPage />} /> */}
        <Route path="kkcdata" element={<VpyData />} errorElement={<ErrorPage />} />

        <Route path="lsn" element={<Lsn />} errorElement={<ErrorPage />} />
        <Route path="mfuncstations" element={<MfuncStations />} errorElement={<ErrorPage />} />
        <Route path="kksstations" element={<KKSStations />} errorElement={<ErrorPage />} />
        <Route path="erastations" element={<ERAStations />} errorElement={<ErrorPage />} />
        <Route path="pyvsrkstations" element={<PUVSRKStations />} errorElement={<ErrorPage />} />
        <Route path="konsulstations" element={<KONSULStations />} errorElement={<ErrorPage />} />
        <Route path="visstations" element={<VISStations />} errorElement={<ErrorPage />} />

        {/* <Route path="game" element={<Game />} errorElement={<ErrorPage />} /> */}
        <Route path="*" element={<ErrorPage errorCode="404" />} />
      </Route>
    </>
  )
  // { basename: "/", }
);

export default App;
